.customValuePill {
  display: flex;
  align-items: center;
  column-gap: var(--spacingSm);
}

.nameWrapper {
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 14px; // Fix overflow on Safari
}

.name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--paletteBlue0);

  &.darkTheme {
    color: var(--paletteWhite0);
  }
}

.actionDiv {
  padding: var(--spacingXs);
  border-radius: var(--radiusSm);
  max-width: fit-content;

  &:hover {
    background-color: var(--paletteTrans0);
  }
}

.pendingApproval {
  opacity: 0.5;
}
